// GENERATED FILE - do not edit.
// Produced by packages/web/src/cli/generate-screen-index.ts.
// Run `pnpm generate` to regenerate.

import type { AnyScreenDefinition } from './types.js';
import { screen as screen_agents_agent_activity } from './agents/agent-activity.screen.js';
import { screen as screen_agents_agent_builder } from './agents/agent-builder.screen.js';
import { screen as screen_agents_agents_list } from './agents/agents-list.screen.js';
import { screen as screen_agents_proposals } from './agents/proposals.screen.js';
import { screen as screen_analytics_coaching } from './analytics/coaching.screen.js';
import { screen as screen_analytics_cohorts } from './analytics/cohorts.screen.js';
import { screen as screen_analytics_dashboard } from './analytics/dashboard.screen.js';
import { screen as screen_analytics_report_builder } from './analytics/report-builder.screen.js';
import { screen as screen_analytics_reports_list } from './analytics/reports-list.screen.js';
import { screen as screen_approvals_approvals } from './approvals/approvals.screen.js';
import { screen as screen_auth_signin } from './auth/signin.screen.js';
import { screen as screen_auth_signup } from './auth/signup.screen.js';
import { screen as screen_catalog_pricelist } from './catalog/pricelist.screen.js';
import { screen as screen_catalog_pricelists_list } from './catalog/pricelists-list.screen.js';
import { screen as screen_catalog_product_editor } from './catalog/product-editor.screen.js';
import { screen as screen_catalog_products_list } from './catalog/products-list.screen.js';
import { screen as screen_catalog_promotions } from './catalog/promotions.screen.js';
import { screen as screen_catalog_variants } from './catalog/variants.screen.js';
import { screen as screen_chat_chat_console } from './chat/chat-console.screen.js';
import { screen as screen_contacts_call_queue } from './contacts/call-queue.screen.js';
import { screen as screen_contacts_contacts_list } from './contacts/contacts-list.screen.js';
import { screen as screen_deals_cadences } from './deals/cadences.screen.js';
import { screen as screen_deals_deal_record } from './deals/deal-record.screen.js';
import { screen as screen_deals_deals_board } from './deals/deals-board.screen.js';
import { screen as screen_deals_deals_list } from './deals/deals-list.screen.js';
import { screen as screen_deals_quote_builder } from './deals/quote-builder.screen.js';
import { screen as screen_deals_quote_template_builder } from './deals/quote-template-builder.screen.js';
import { screen as screen_flows_automation_builder } from './flows/automation-builder.screen.js';
import { screen as screen_flows_automations_list } from './flows/automations-list.screen.js';
import { screen as screen_flows_chatbot_builder } from './flows/chatbot-builder.screen.js';
import { screen as screen_flows_journeys_list } from './flows/journeys-list.screen.js';
import { screen as screen_flows_recipe_gallery } from './flows/recipe-gallery.screen.js';
import { screen as screen_flows_run_log } from './flows/run-log.screen.js';
import { screen as screen_flows_segment_builder } from './flows/segment-builder.screen.js';
import { screen as screen_forecast_forecast } from './forecast/forecast.screen.js';
import { screen as screen_home_home } from './home/home.screen.js';
import { screen as screen_marketing_asset_library } from './marketing/asset-library.screen.js';
import { screen as screen_marketing_campaign_record } from './marketing/campaign-record.screen.js';
import { screen as screen_marketing_campaigns_list } from './marketing/campaigns-list.screen.js';
import { screen as screen_marketing_campaigns_table } from './marketing/campaigns-table.screen.js';
import { screen as screen_marketing_email_builder } from './marketing/email-builder.screen.js';
import { screen as screen_marketing_event_record } from './marketing/event-record.screen.js';
import { screen as screen_marketing_journey_builder } from './marketing/journey-builder.screen.js';
import { screen as screen_marketing_landing_builder } from './marketing/landing-builder.screen.js';
import { screen as screen_marketing_segments_list } from './marketing/segments-list.screen.js';
import { screen as screen_onboarding_wizard } from './onboarding/wizard.screen.js';
import { screen as screen_portal_approve_from_email } from './portal/approve-from-email.screen.js';
import { screen as screen_portal_booking_page } from './portal/booking-page.screen.js';
import { screen as screen_portal_booking } from './portal/booking.screen.js';
import { screen as screen_portal_confirm_consent } from './portal/confirm-consent.screen.js';
import { screen as screen_portal_customer_portal } from './portal/customer-portal.screen.js';
import { screen as screen_portal_event_registration } from './portal/event-registration.screen.js';
import { screen as screen_portal_landing_page } from './portal/landing-page.screen.js';
import { screen as screen_portal_partner_portal } from './portal/partner-portal.screen.js';
import { screen as screen_portal_preference_centre } from './portal/preference-centre.screen.js';
import { screen as screen_portal_survey } from './portal/survey.screen.js';
import { screen as screen_records_account_record } from './records/account-record.screen.js';
import { screen as screen_records_companies_list } from './records/companies-list.screen.js';
import { screen as screen_records_contact_record } from './records/contact-record.screen.js';
import { screen as screen_records_convert_lead } from './records/convert-lead.screen.js';
import { screen as screen_records_lead_record } from './records/lead-record.screen.js';
import { screen as screen_records_leads_list } from './records/leads-list.screen.js';
import { screen as screen_revenue_churn } from './revenue/churn.screen.js';
import { screen as screen_revenue_commission } from './revenue/commission.screen.js';
import { screen as screen_revenue_dunning } from './revenue/dunning.screen.js';
import { screen as screen_revenue_invoices } from './revenue/invoices.screen.js';
import { screen as screen_revenue_renewals } from './revenue/renewals.screen.js';
import { screen as screen_revenue_revenue } from './revenue/revenue.screen.js';
import { screen as screen_revenue_subscription_record } from './revenue/subscription-record.screen.js';
import { screen as screen_revenue_unit_economics } from './revenue/unit-economics.screen.js';
import { screen as screen_service_case_record } from './service/case-record.screen.js';
import { screen as screen_service_cases_audit } from './service/cases-audit.screen.js';
import { screen as screen_service_cases_list } from './service/cases-list.screen.js';
import { screen as screen_setup_field_editor } from './setup/field-editor.screen.js';
import { screen as screen_setup_import } from './setup/import.screen.js';
import { screen as screen_setup_layout_builder } from './setup/layout-builder.screen.js';
import { screen as screen_setup_modules } from './setup/modules.screen.js';
import { screen as screen_setup_plan } from './setup/plan.screen.js';
import { screen as screen_setup_setup_home } from './setup/setup-home.screen.js';
import { screen as screen_shared_search } from './shared/search.screen.js';
import { screen as screen_work_my_work } from './work/my-work.screen.js';

/** Every screen module, keyed by its path relative to this directory. */
export const SCREEN_MODULES: Record<string, AnyScreenDefinition> = {
  "./agents/agent-activity.screen.tsx": screen_agents_agent_activity,
  "./agents/agent-builder.screen.tsx": screen_agents_agent_builder,
  "./agents/agents-list.screen.tsx": screen_agents_agents_list,
  "./agents/proposals.screen.tsx": screen_agents_proposals,
  "./analytics/coaching.screen.tsx": screen_analytics_coaching,
  "./analytics/cohorts.screen.tsx": screen_analytics_cohorts,
  "./analytics/dashboard.screen.tsx": screen_analytics_dashboard,
  "./analytics/report-builder.screen.tsx": screen_analytics_report_builder,
  "./analytics/reports-list.screen.tsx": screen_analytics_reports_list,
  "./approvals/approvals.screen.tsx": screen_approvals_approvals,
  "./auth/signin.screen.tsx": screen_auth_signin,
  "./auth/signup.screen.tsx": screen_auth_signup,
  "./catalog/pricelist.screen.tsx": screen_catalog_pricelist,
  "./catalog/pricelists-list.screen.tsx": screen_catalog_pricelists_list,
  "./catalog/product-editor.screen.tsx": screen_catalog_product_editor,
  "./catalog/products-list.screen.tsx": screen_catalog_products_list,
  "./catalog/promotions.screen.tsx": screen_catalog_promotions,
  "./catalog/variants.screen.tsx": screen_catalog_variants,
  "./chat/chat-console.screen.tsx": screen_chat_chat_console,
  "./contacts/call-queue.screen.tsx": screen_contacts_call_queue,
  "./contacts/contacts-list.screen.tsx": screen_contacts_contacts_list,
  "./deals/cadences.screen.tsx": screen_deals_cadences,
  "./deals/deal-record.screen.tsx": screen_deals_deal_record,
  "./deals/deals-board.screen.tsx": screen_deals_deals_board,
  "./deals/deals-list.screen.tsx": screen_deals_deals_list,
  "./deals/quote-builder.screen.tsx": screen_deals_quote_builder,
  "./deals/quote-template-builder.screen.tsx": screen_deals_quote_template_builder,
  "./flows/automation-builder.screen.tsx": screen_flows_automation_builder,
  "./flows/automations-list.screen.tsx": screen_flows_automations_list,
  "./flows/chatbot-builder.screen.tsx": screen_flows_chatbot_builder,
  "./flows/journeys-list.screen.tsx": screen_flows_journeys_list,
  "./flows/recipe-gallery.screen.tsx": screen_flows_recipe_gallery,
  "./flows/run-log.screen.tsx": screen_flows_run_log,
  "./flows/segment-builder.screen.tsx": screen_flows_segment_builder,
  "./forecast/forecast.screen.tsx": screen_forecast_forecast,
  "./home/home.screen.tsx": screen_home_home,
  "./marketing/asset-library.screen.tsx": screen_marketing_asset_library,
  "./marketing/campaign-record.screen.tsx": screen_marketing_campaign_record,
  "./marketing/campaigns-list.screen.tsx": screen_marketing_campaigns_list,
  "./marketing/campaigns-table.screen.tsx": screen_marketing_campaigns_table,
  "./marketing/email-builder.screen.tsx": screen_marketing_email_builder,
  "./marketing/event-record.screen.tsx": screen_marketing_event_record,
  "./marketing/journey-builder.screen.tsx": screen_marketing_journey_builder,
  "./marketing/landing-builder.screen.tsx": screen_marketing_landing_builder,
  "./marketing/segments-list.screen.tsx": screen_marketing_segments_list,
  "./onboarding/wizard.screen.tsx": screen_onboarding_wizard,
  "./portal/approve-from-email.screen.tsx": screen_portal_approve_from_email,
  "./portal/booking-page.screen.tsx": screen_portal_booking_page,
  "./portal/booking.screen.tsx": screen_portal_booking,
  "./portal/confirm-consent.screen.tsx": screen_portal_confirm_consent,
  "./portal/customer-portal.screen.tsx": screen_portal_customer_portal,
  "./portal/event-registration.screen.tsx": screen_portal_event_registration,
  "./portal/landing-page.screen.tsx": screen_portal_landing_page,
  "./portal/partner-portal.screen.tsx": screen_portal_partner_portal,
  "./portal/preference-centre.screen.tsx": screen_portal_preference_centre,
  "./portal/survey.screen.tsx": screen_portal_survey,
  "./records/account-record.screen.tsx": screen_records_account_record,
  "./records/companies-list.screen.tsx": screen_records_companies_list,
  "./records/contact-record.screen.tsx": screen_records_contact_record,
  "./records/convert-lead.screen.tsx": screen_records_convert_lead,
  "./records/lead-record.screen.tsx": screen_records_lead_record,
  "./records/leads-list.screen.tsx": screen_records_leads_list,
  "./revenue/churn.screen.tsx": screen_revenue_churn,
  "./revenue/commission.screen.tsx": screen_revenue_commission,
  "./revenue/dunning.screen.tsx": screen_revenue_dunning,
  "./revenue/invoices.screen.tsx": screen_revenue_invoices,
  "./revenue/renewals.screen.tsx": screen_revenue_renewals,
  "./revenue/revenue.screen.tsx": screen_revenue_revenue,
  "./revenue/subscription-record.screen.tsx": screen_revenue_subscription_record,
  "./revenue/unit-economics.screen.tsx": screen_revenue_unit_economics,
  "./service/case-record.screen.tsx": screen_service_case_record,
  "./service/cases-audit.screen.tsx": screen_service_cases_audit,
  "./service/cases-list.screen.tsx": screen_service_cases_list,
  "./setup/field-editor.screen.tsx": screen_setup_field_editor,
  "./setup/import.screen.tsx": screen_setup_import,
  "./setup/layout-builder.screen.tsx": screen_setup_layout_builder,
  "./setup/modules.screen.tsx": screen_setup_modules,
  "./setup/plan.screen.tsx": screen_setup_plan,
  "./setup/setup-home.screen.tsx": screen_setup_setup_home,
  "./shared/search.screen.tsx": screen_shared_search,
  "./work/my-work.screen.tsx": screen_work_my_work,
};

/** The number of screen files this index was generated from. */
export const SCREEN_MODULE_COUNT = 81;
